@if (!loading() && dashboardData()) {
  <div class="dashboard-container">
    <h2>Dashboard de Alarmas</h2>
    <div class="filters-container">
      <mat-form-field appearance="outline">
        <mat-label>Monitor</mat-label>
        <mat-select [ngModel]="monitorId()" (ngModelChange)="onMonitorChange($event)">
          <mat-option [value]="''">Todos</mat-option>
          @for (m of monitor(); track m.id) {
            <mat-option [value]="m.id">{{ m.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Rango rápido</mat-label>
        <mat-select
          [(ngModel)]="filters.dateRangePreset"
          (selectionChange)="onDateRangePresetChange($event.value)"
          >
          <mat-option value="TODAY">Hoy</mat-option>
          <mat-option value="LAST_7_DAYS">Últimos 7 días</mat-option>
          <mat-option value="LAST_MONTH">Último mes</mat-option>
          <mat-option value="LAST_3_MONTHS">Últimos 3 meses</mat-option>
          <mat-option value="">Ninguno</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-fecha-desde">
        <mat-label>Fecha desde</mat-label>
        <input
          matInput
          [matDatepicker]="fromPicker"
          [(ngModel)]="filters.fechaDesde"
          [disabled]="!isFiltreDate()"
          />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromPicker"
          [disabled]="!isFiltreDate()"
        ></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-fecha-hasta">
        <mat-label>Fecha hasta</mat-label>
        <input
          matInput
          [matDatepicker]="toPicker"
          [(ngModel)]="filters.fechaHasta"
          [disabled]="!isFiltreDate()"
          />
        <mat-datepicker-toggle
          matSuffix
          [for]="toPicker"
          [disabled]="!isFiltreDate()"
        ></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
      <div class="button-filters">
        <button
          mat-flat-button
          color="primary"
          class="filter-btn"
          (click)="applyFilters()"
          >
          <mat-icon>filter_alt</mat-icon>
          Filtrar
        </button>
        <button
          mat-stroked-button
          color="warn"
          class="clear-filter-btn"
          (click)="resetFilters()"
          >
          <mat-icon>close</mat-icon>
          Limpiar
        </button>
      </div>
    </div>
    <div class="stats-cards">
      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-top">
            <mat-icon class="stat-icon">notifications</mat-icon>
            <div class="stat-number">{{ dashboardData()?.statusDistribution?.total }}</div>
          </div>
          <div class="stat-label">Total Alarmas</div>
        </mat-card-content>
      </mat-card>
      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-top">
            <mat-icon class="stat-icon">check_circle</mat-icon>
            <div class="stat-number">{{ dashboardData()?.statusSummary?.classified }}</div>
          </div>
          <div class="stat-label">Clasificadas</div>
        </mat-card-content>
      </mat-card>
      <mat-card class="stat-card" [class.highlight-unclassified]="isUnclassifiedGreater()">
        <mat-card-content>
          <div class="stat-top">
            <mat-icon class="stat-icon">help_outline</mat-icon>
            <div class="stat-number">{{ dashboardData()?.statusSummary?.unclassified }}</div>
          </div>
          <div class="stat-label">Sin Clasificar</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="dashboard-main-content">
      <div class="charts-section">
        <div class="charts-grid">
          <div class="chart-container">
            <canvas
              baseChart
              [data]="statusChartData"
              [options]="statusChartOptions"
              [type]="statusChartType"
              >
            </canvas>
          </div>
          <div class="chart-container">
            <canvas
              baseChart
              [data]="summaryChartData"
              [options]="summaryChartOptions"
              [type]="summaryChartType"
              >
            </canvas>
          </div>
          <div class="chart-container">
            <canvas
              baseChart
              [data]="eventChartData"
              [options]="eventChartOptions"
              [type]="eventChartType"
              >
            </canvas>
          </div>
          <div class="chart-container">
            <canvas
              baseChart
              [data]="timeSeriesChartData"
              [options]="timeSeriesChartOptions"
              [type]="timeSeriesChartType"
              >
            </canvas>
          </div>
        </div>
      </div>
      <div class="top-resolvers">
        <h3>Top Monitoristas</h3>
        <ul>
          @for (resolver of dashboardData()?.topResolvers; track resolver) {
            <li>
              <div class="resolver-info">
                <span class="resolver-name">{{ resolver.resolverName }}</span>
              </div>
              <div class="resolver-count">
                {{ resolver.classifiedCount }}
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
}

<!-- Spinner de carga -->
@if (loading()) {
  <div class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Cargando datos del dashboard...</p>
  </div>
}

<!-- Mensaje de error -->
@if (error()) {
  <div class="error-container">
    <mat-icon color="warn">error</mat-icon>
    <p>{{ error() }}</p>
  </div>
}

